var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goods-info-labels"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.labels))])])
}
var staticRenderFns = []

export { render, staticRenderFns }